module.exports = __webpack_public_path__ + "static/media/BAJFINANCE.7f4094bd.txt";